module.exports = __webpack_public_path__ + "img/stats.708daa97.svg";